var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 302,
    viewBox: "0 0 136 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.219 34.332L67.998 0L0.776919 34.332H0.1875V301.196H135.96V34.332H135.219Z",
    fill: "url(#paint0_linear_18473_62896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18473_62896",
    x1: 135.96,
    y1: -0.0000038333,
    x2: -5.44493,
    y2: 298.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkBg);
export default __webpack_public_path__ + "static/media/bulk-bg.47725a95f4ef636d34e7ddec9ceb3143.svg";
export { ForwardRef as ReactComponent };